import { Component, EventEmitter, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import ColorHelpers from '../helpers/color-helpers';

@Component({
  selector: 'app-color-picker-dialog',
  template: `
    <app-color-picker
      [currentColor]="data.currentColor"
      [inputAccountColors]="data.accountColors"
      [isSourceGradient]="true"
      (customColorUpdated)="onColorUpdated($event)"
      (enterInput)="onClose()">
    </app-color-picker>
  `,
  styles: [
    `
      :host {
        display: block;
        padding: 0px 16px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ColorPickerDialogComponent {
  colorUpdated = new EventEmitter<string>();

  constructor(
    public dialogRef: MatDialogRef<ColorPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { currentColor: string; accountColors?: any[] },
  ) {}

  onColorUpdated(color: string | null): void {
    if (color) {
      const resolvedColor = ColorHelpers.isAccountVariable(color)
        ? (ColorHelpers.getColorFromAccountVariable(color, this.data.accountColors ?? []) ?? color)
        : color;
      this.colorUpdated.emit(resolvedColor);
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
